var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MenuList',{attrs:{"is-visible":_vm.isVisibleMenu,"menu-list":_vm.menuList},on:{"close":_vm.closeMenu},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('PSwitchableAccountList')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }